import {
    serviceOperationalCapacityUnitEnumOptionsByType,
} from './../../../../../../../../../types/src/services/enum/service-operational-capacity-unit.enum';
import { Component, computed, effect, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { Validators } from '@angular/forms';
import { isInvalid } from '../../../../../shared/helpers/validate';
import { ServiceOperationalCapacityModalStore } from './service-operational-capacity-modal.store';
import {
    ServiceOperationalCapacityObject,
} from '@libs/types/src/services/object-type/service/settings/service-operational-capacity.object';
import {
    ServiceOperationalCapacityCreateInput,
} from '@libs/types/src/services/input-type/services/settings/service-operational-capacity.create-input';
import {
    ServiceOperationalCapacityUpdateInput,
} from '@libs/types/src/services/input-type/services/settings/service-operational-capacity.update-input';
import { dateify, dateifyOrNow } from '../../../../../shared/helpers/date.helper';
import { contentGlobalSuccess } from '../../../../content.error';
import { fb, routeParams } from '../../../../../shared/shared.global-service';
import { Dialog } from '@openng/optimus-ui/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { DateInputComponent } from '../../../../../../components/kit/input/date-input/date-input.component';
import { SelectInputComponent } from '../../../../../../components/kit/input/select-input/select-input.component';
import { NumberInputComponent } from '../../../../../../components/kit/input/text-input/number-input.component';
import { TextInputComponent } from '../../../../../../components/kit/input/text-input/text-input.component';
import { CheckInputComponent } from '../../../../../../components/kit/input/check-input/check-input.component';
import { ActionButtonsComponent } from '../../../../../../components/kit/action-buttons/action-buttons.component';

@Component({
    selector: 'app-service-operational-capacity-modal',
    templateUrl: 'service-operational-capacity-modal.component.html',
    styleUrl: 'service-operational-capacity-modal.component.scss',
    providers: [ServiceOperationalCapacityModalStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        Dialog,
        TranslatePipe,
        DateInputComponent,
        SelectInputComponent,
        NumberInputComponent,
        TextInputComponent,
        CheckInputComponent,
        ActionButtonsComponent,
    ],
})
export class ServiceOperationalCapacityModalComponent extends SubscriptionComponent {

    protected readonly store = inject(ServiceOperationalCapacityModalStore);

    @Input() operationalCapacity: ServiceOperationalCapacityObject | null = null;

    protected visible = false;

    protected readonly initialState = {
        amount: 1,
        dateFrom: new Date(),
        required: true,
        fullWeekService: false,
    };

    protected form = fb.group({
        name: fb.control<string | null>(null, Validators.required),
        amount: fb.control<number>(this.initialState.amount, Validators.required),
        dateFrom: fb.control<Date>(this.initialState.dateFrom, Validators.required),
        dateTo: fb.control<Date | null>(null),
        description: fb.control<string | null>(null),

        fullWeekService: fb.control<boolean>(this.initialState.fullWeekService),
        form: fb.control<string | null>(null),
    });

    protected unitOptions = computed(() => {
        return serviceOperationalCapacityUnitEnumOptionsByType(this.store.service()?.type);
    });

    constructor() {
        super();

        effect(() => {
            if (this.store.isSocial()) {
                this.form.controls.form.setValidators(Validators.required);
            } else {
                this.form.controls.form.clearValidators();
            }
            this.form.controls.form.updateValueAndValidity();
        });
    }

    public show(visible: boolean = true, operationalCapacity: ServiceOperationalCapacityObject | null = null): void {
        this.visible = visible;
        this.operationalCapacity = operationalCapacity;
        if (operationalCapacity) {
            this.form.patchValue({
                ...operationalCapacity,
                dateFrom: dateifyOrNow(operationalCapacity.dateFrom),
                dateTo: dateify(operationalCapacity.dateTo),
            });
        } else {
            this.form.reset(this.initialState);
        }
    }

    protected async submit(): Promise<void> {
        if (isInvalid(this.form)) return;

        if (!this.operationalCapacity) {
            const serviceId = Number(routeParams.serviceId());
            await this.store.api.createServiceOperationalCapacity({
                serviceId,
                ...this.form.value,
                dateFrom: this.form.value.dateFrom?.toISOString(),
                dateTo: this.form.value.dateTo?.toISOString(),
                description: this.form.value.description || '',
            } as ServiceOperationalCapacityCreateInput);
            contentGlobalSuccess.next('common.created');
        } else {
            await this.store.api.updateServiceOperationalCapacity({
                id: this.operationalCapacity!.id,
                ...this.form.value,
                dateFrom: this.form.value.dateFrom?.toISOString(),
                dateTo: this.form.value.dateTo?.toISOString(),
                description: this.form.value.description || '',
            } as ServiceOperationalCapacityUpdateInput);
            contentGlobalSuccess.next('common.updated');
        }

        this.show(false);
    }

}
